module.exports = __webpack_public_path__ + "assets/studyset-creativity.f0218bba.svg";